"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useContextWithErrorHandler = (context, providerName) => {
    const ctx = react_1.useContext(context);
    if (!Object.keys(ctx).length || ctx === undefined || ctx === null)
        throw new Error(`Must be called within <${providerName}>`);
    return ctx;
};
exports.default = useContextWithErrorHandler;
